import React, {useState} from 'react';
import {Button, Form, Input, message} from 'antd';
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {collection, getDocs, query, where} from 'firebase/firestore';
import {db} from '../../config/firebase';
import {useNavigate} from 'react-router-dom';

interface LoginForm {
    username: string;
    password: string;
}

interface AdminUser {
    id: string;
    username: string;
    password: string;
    email: string;
    role: string;
    lastLoginTime?: number;
}

const Login: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values: LoginForm) => {
        try {
            setLoading(true);

            // 查询用户
            const usersRef = collection(db, 'admins');
            const q = query(
                usersRef,
                where('username', '==', values.username),
                where('password', '==', values.password)
            );

            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                message.error('Invalid username or password');
                return;
            }

            // 获取用户数据
            const userData = querySnapshot.docs[0].data() as AdminUser;
            const userId = querySnapshot.docs[0].id;

            // 存储登录状态到 localStorage
            const loginInfo = {
                id: userId,
                username: userData.username,
                email: userData.email,
                role: userData.role,
                loginTime: new Date().getTime()
            };

            localStorage.setItem('adminUser', JSON.stringify(loginInfo));

            message.success('Login successful');
            navigate('/');

        } catch (error) {
            console.error('Login error:', error);
            message.error('Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-lg">
                <div>
                    <h2 className="text-center text-3xl font-extrabold text-gray-900">
                        Admin Login
                    </h2>
                </div>
                <Form
                    name="login"
                    onFinish={onFinish}
                    className="mt-8 space-y-6"
                >
                    <Form.Item
                        name="username"
                        rules={[
                            {required: true, message: 'Please input your username!'}
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined/>}
                            placeholder="Username"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            {required: true, message: 'Please input your password!'},
                            {min: 6, message: 'Password must be at least 6 characters!'}
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined/>}
                            placeholder="Password"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="w-full"
                            size="large"
                            loading={loading}
                        >
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Login;
